import * as React from 'react';
import { render } from 'react-dom';
import { getLogger } from '@cian/logger/browser';
import { ErrorLogComponent } from '@cian/error-log-component';

import { BackToAdPopup, IBackToAdPopupProps } from './back_to_ad_popup';

export const renderBackToAdPopup = (container: Element, props: IBackToAdPopupProps): void => {
  render(
    <ErrorLogComponent logger={getLogger()}>
      <BackToAdPopup {...props} />
    </ErrorLogComponent>,
    container,
  );
};
